const apiBaseURL = 'https://api.crossout-chat-translator.xyz';

export default apiBaseURL;
